import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import type { OnItemDrop } from '@atlassian/jira-software-roadmap-timeline-table/src/common/types/callbacks.tsx';
import type { ListItemMenuOptionProps } from '@atlassian/jira-software-roadmap-timeline-table/src/renderers/index.tsx';
import type { OnJiraItemUpdate } from '../../../controllers/update-item/types.tsx';
import { CHANGE_PARENT_ISSUE, EDIT_DATES, REMOVE_DATES, EDIT_DEPENDENCY } from '../constants.tsx';
import EditDatesOption from './edit-dates-option/index.tsx';
import EditDependencyOption from './edit-dependency-option/index.tsx';
import RemoveDatesOption from './remove-dates-option/index.tsx';
import ReparentMenuOption from './reparent-menu-option/index.tsx';

type Props = ListItemMenuOptionProps & {
	optionId: string;
	updateIssueParent: OnItemDrop;
	onItemUpdate: OnJiraItemUpdate;
};

const ListItemMenuOption = ({
	optionId,
	id,
	Option,
	setCloseMenu,
	setOpenModal,
	updateIssueParent,
	onItemUpdate,
}: Props) => {
	switch (optionId) {
		case CHANGE_PARENT_ISSUE:
			return fg('jwm_timeline_meatball_reparent_menu') ? (
				<ReparentMenuOption
					id={id}
					Option={Option}
					setCloseMenu={setCloseMenu}
					updateIssueParent={updateIssueParent}
				/>
			) : null;
		case REMOVE_DATES:
			return fg('jwm_timeline_meatballs_date_update') ? (
				<RemoveDatesOption
					id={id}
					Option={Option}
					setCloseMenu={setCloseMenu}
					onItemUpdate={onItemUpdate}
				/>
			) : null;
		case EDIT_DATES:
			return fg('jwm_timeline_meatballs_date_update') ? (
				<EditDatesOption id={id} setOpenModal={setOpenModal} Option={Option} />
			) : null;
		case EDIT_DEPENDENCY:
			return fg('jwm_timeline_meatballs_edit_dependency') ? (
				<EditDependencyOption id={id} setOpenModal={setOpenModal} Option={Option} />
			) : null;
		default:
			return null;
	}
};

export default ListItemMenuOption;
